<template>
    <div class="trophy-item align-center relative bronze" :class="['size-' + size, { 'tw-h-auto': view === 'profile' }]">
        <div :class="{ 'trophy-item-absolute': view !== 'profile' }">
            <div class="hexagon mimic-title" :class="rankClass">
                <i :class="trophy.icon"></i>
                <span v-if="showTooltip">{{ translations[trophy.description] }}</span>
                <div class="stars-wrapper">
                    <template v-for="n in 3">
                        <i class="far fa-star" :class="{ 'fa': rank >= n }"></i>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="trophy.activatable == 1 && trophy.progress == 100 && activeTrophy.id !== trophy.id && !displayOnly"
            class="active-trophy-toggle absolute align-center hover no-select" @click="setActiveTrophy(trophy)">
            <i class="fa fa-check"></i>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Global from '../../mixins/Global.js'

export default {
    name: 'TrophyHexagon',
    mixins: [Global],

    props: {
        trophy: {
            required: true,
        },
        size: {
            default: 75,
        },
        displayOnly: {
            default: false,
        },
        view: {

        },
        showTooltip: {
            default: true,
        },
    },

    computed: {
        ...mapState([
            'activeTrophy',
        ]),

        rank() {
            if (this.view !== 'unachieved') {
                if (this.trophy.rank === 3) {
                    if (this.trophy.user_score >= this.trophy.threshold) {
                        return 3;
                    }

                    return 2;
                }

                return this.trophy.rank - 1;
            } else {
                return this.trophy.rank;
            }
        },

        //[{'bronze': trophy.rank === 1 || trophy.rank === 2}, {'silver': trophy.rank === 3 && trophy.user_score < trophy.threshold}, {'gold': trophy.rank === 3  && trophy.user_score >= trophy.threshold}]
        rankClass() {
            if (this.view !== 'unachieved') {
                if (typeof this.trophy.user_score === 'undefined') {
                    if (this.trophy.rank === 1) {
                        return 'bronze';
                    } else if (this.trophy.rank === 2) {
                        return 'silver';
                    }

                    return 'gold';
                } else {
                    if (this.trophy.rank === 1 || this.trophy.rank === 2) {
                        return 'bronze';
                    } else if (this.trophy.rank === 3 && this.trophy.user_score < this.trophy.threshold) {
                        return 'silver';
                    }

                    return 'gold';
                }
            } else {
                if (this.rank === 2) {
                    return 'silver';
                } else if (this.rank === 3) {
                    return 'gold';
                }

                return 'bronze';
            }
        }
    },

    methods: {
        setActiveTrophy(trophy) {
            this.$store.dispatch('storeActiveTrophy', trophy);
        }
    },
}
</script>